import React, { useRef, useState } from "react";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";



// components
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM,
    LB_ACTIVE, LB_EVENT,
} from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// actions

import SelectGeneric from "../../../components/select/selectGeneric";
import {activityProvider} from "../../../providers/activityProvider";
import {placeProvider} from "../../../providers/placeProvider";

// services
import {itineraryService} from "../../../jwt/_services/eventx/ItineraryService";

// providers
import {eventProvider} from "../../../providers/eventx/eventProvider";
import {paxProvider} from "../../../providers/clasificators/paxProvider";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";


const ItineraryForm = props => {
    // const { app, udn } = props.mainProps
    // const { editMode, disableInputs, domainObject } = props.formProps;

    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject } = componentState?.data;

    const [showModal, setShowModal] = useState(true)
    const [status, setStatus] = useState( domainObject?.status !== undefined ? domainObject?.status : true);
    const [fullDay, setFullDay] = useState( domainObject?.fullDay !== undefined ? domainObject?.fullDay : false);

    const [hourStart, setHourStrart] = useState( editMode ? domainObject?.timeStart : '' )
    const [hourEnd, setHourEnd] = useState( editMode ? domainObject?.timeEnd : '' )

    const [categoryId, setCategoryId] = useState(  domainObject?.category?.id || null);

    const [activityId, setActivityId] = useState(  domainObject?.activity || null);
    const [placeId, setPlaceId] = useState(  domainObject?.place?.id || null);
    const [validActivity, setValidActivity] = useState(  true);
    const [event, setEvent] = useState(domainObject?.event?.id || null);
    const [validEvent, setValidEvent] = useState(  true);
    const [paxId, setPaxId] = useState( domainObject?.pax?.id || null);

    const modalRef = useRef(null);


    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        date : Yup.string().required('La fecha es requerida'),
        timeStart : Yup.string().required('La hora de inicio es requerida'),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            date: domainObject?.date,
            duration: domainObject?.duration,
            timeStart: domainObject?.timeStart,
            timeEnd: domainObject?.timeEnd,
        }
    });

    const validateSubmit = () => {
        if (event === null) {
            setValidEvent(false);
            return false;
        }

        if (activityId === null) {
            setValidActivity(false);
            return false;
        }

        return true
    }

    const onSubmit = (data, _) => {
        if (!validateSubmit())
            return;

        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                status,

                udn : { id : udn.id }
            }
        };

        if(event != null)
            dataRequest.item.event = { id : event };

        if (categoryId != null)
            dataRequest.item.category = { id : categoryId };

        if (activityId != null)
            dataRequest.item.activity = { id : activityId };

        if (placeId != null)
            dataRequest.item.place = { id : placeId };

        // console.log('dataRequest', dataRequest);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, itineraryService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, itineraryService, dataRequest)
        }


        returnToList()
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: itineraryService
        } );
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
    <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > { 'Itinerario' }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { 'uid: ' + domainObject?.uid }</h5>
                </>
                <div className="top-right">
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode &&
                        <>
                            <Separator/>
                            <GenericButton
                                style={'table'}
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={itineraryService} />
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_DELETE}
                                icon={'fa-trash'}
                                permission={'delete'}
                                onClick={_ => confirmDelete(domainObject)}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={returnToList}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>{ 'Fecha' }</Label>
                                <Input type="date"
                                       name="date"
                                       placeholder={ 'Fecha' }
                                       innerRef={register}
                                       invalid={ errors.date }
                                />
                                { errors.date && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.date?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Hora de inicio</Label>
                                <Input
                                    type="time"
                                    name="timeStart"
                                    value={ hourStart }
                                    onChange={ e => setHourStrart( e.target.value ) }
                                    innerRef={ register }
                                    placeholder="Ingrese hora"
                                    invalid={ errors.timeStart }
                                />
                                { errors.timeStart && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.timeStart?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Hora de fin</Label>
                                <Input
                                    type="time"
                                    name="timeEnd"
                                    value={ hourEnd }
                                    onChange={ e => setHourEnd( e.target.value ) }
                                    innerRef={ register }
                                    placeholder="Ingrese hora"
                                    invalid={ errors.timeEnd }
                                />
                                { errors.timeEnd && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.timeEnd?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_ACTIVE}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={ status }
                                    onChange={ _ => setStatus(!status) }
                                />

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className={(!validEvent ? 'label-is-invalid' : '')}>{ LB_EVENT }</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={ event }
                                    hasError={ !validEvent }
                                    setExternalValue={ setEvent }
                                    provider = { eventProvider }
                                    customFilter={{ item: { udn: {id: udn?.id }, status: true }} }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className={(!validActivity ? 'label-is-invalid' : '')}>{ 'Actividad / Presentación' }</Label>
                                <SelectGeneric
                                    initialValue={ activityId }
                                    setExternalValue={ value =>  setActivityId(value) }
                                    hasError={ !validActivity }
                                    provider = { activityProvider }
                                    customFilter={{
                                        onlyRegistered: true,
                                        fbDataBase :  { id : app?.fbDataBase?.id },
                                        item: {
                                            udn: { id: udn?.id },
                                            status : null,
                                            isExtraordinary: false
                                        }
                                    }}
                                    resetValue={ false }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ 'Foro / Lugar' }</Label>
                                <SelectGeneric
                                    initialValue={ placeId }
                                    setExternalValue={ value =>  setPlaceId(value) }
                                    provider = { placeProvider }
                                    customFilter={{
                                        onlyRegistered: true,
                                        fbDataBase :  { id : app?.fbDataBase?.id },
                                        item: { udn: {id: udn?.id } }
                                    }}
                                    resetValue={ false }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ 'Anfitrion' }</Label>
                                <SelectGeneric
                                    initialValue={ paxId }
                                    setExternalValue={ value =>  setPaxId(value) }
                                    provider = { paxProvider }
                                    customFilter={{
                                        onlyRegistered: true,
                                        fbDataBase :  { id : app?.fbDataBase?.id },
                                        item: { }
                                    }}
                                    resetValue={ false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />

            </CardBody>
        </Card>
    </Form>
        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(ItineraryForm)